import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import SettingsPersonalSecurityContent from "./SettingsPersonalSecurityContent";
import SettingsPersonalSecurityButtons from "./widget/SettingsPersonalSecurityButtons";
import { SettingsPersonalSecurityContextProvider } from "../../../../provider/settings/security/personal_security/SettingsPersonalSecurityContextProvider";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const SettingsPersonalSecurityScreen = () => {
  const type: number = ResponsiveDeviceType();

  const [title, setTitle] = useState<string>("");
  const [name, setName] = useState<string>("");

  const setupTitle = () => {
    //const pathArr: Array<string> = location.pathname.split("/");
    //const pathName: string = pathArr[pathArr.length - 1];
    const pathName: string = UtilityHelper.getUrlLastPathName();

    setTitle(
      pathName === "update-password"
        ? AppTranslation.text("update_password")
        : pathName === "update-email"
        ? AppTranslation.text("update_email")
        : AppTranslation.text("update_phone_number")
    );
    setName(
      pathName === "update-password"
        ? "password"
        : pathName === "update-email"
        ? "email"
        : "phone"
    );
  };

  useEffect(() => {
    setupTitle();
  }, []);

  return (
    <SettingsPersonalSecurityContextProvider>
      <Scaffold
        appBarTitle={title}
        bottomNavigationButton={<SettingsPersonalSecurityButtons name={name} />}
      >
        <MainBodyContainer>
          <SettingsPersonalSecurityContent type={type} name={name} />
        </MainBodyContainer>
      </Scaffold>
    </SettingsPersonalSecurityContextProvider>
  );
};

export default SettingsPersonalSecurityScreen;
export const routeName: string = "/settings/personal-security";
export const routeNamePassword: string =
  "/settings/personal-security/update-password";
export const routeNameEmail: string =
  "/settings/personal-security/update-email";
export const routeNamePhone: string =
  "/settings/personal-security/update-phone";
